<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp; Article Debit Credit Hours</h5>
  </div>
  <div id="mainContent" class="container">
    <div class="modal-body">
      <div class="row">
        <div class="col-sm-5">
          <div class="row">
            <label class="col-sm-4 col-form-label">Financial Year<span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <select class="form-control form-control-xs mt-1" [(ngModel)]="selectedFinancialYear"
                (change)="onYearselected()">
                <option value="">Select Year</option>
                <option *ngFor="let finance of financialYearList" [ngValue]="finance">
                  {{ finance.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="row">
            <label class="col-sm-4 col-form-label">Branch<span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <mat-form-field appearance="legacy" style="width: 100%">
                <mat-select multiple [(ngModel)]="selectedBranch" #designateBranch="ngModel">
                  <mat-option (click)="selectAllBranch(designateBranch, branchList)" [value]="0">Select All
                  </mat-option>
                  <mat-option #item (click)="onBranchSelected()" *ngFor="let branch of branchList" [value]="branch">
                    {{ branch.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-5">
          <div class="row">
            <div class="col-sm-4">
              <label>Role <span class="text-danger">*</span></label>
            </div>

            <div class="col-sm-6">
              <div class="input-group">
                <input class="form-control form-control-xs" [(ngModel)]="role" />
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-5">
          <div class="row">
            <label class="col-sm-4 col-form-label">
              Reporting Partner<span class="text-danger">*</span>
            </label>

            <div class="col-sm-6">
              <select class="form-control form-control-xs mt-1" [(ngModel)]="selectedPartner"
                (change)="onUserSelected()">
                <option value="">Select Partner</option>

                <option *ngFor="let partner of partnerList" [ngValue]="partner">
                  {{ partner.firstName }}
                  {{ partner.middleName }}
                  {{ partner.lastName }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-5">
          <div class="row">
            <label class="col-sm-4 col-form-label">Article Name<span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <mat-form-field appearance="legacy" style="width: 100%">
                <mat-select multiple [(ngModel)]="selectArticle" #designateArticleName="ngModel">
                  <mat-option (click)="selectAllArticleName(designateArticleName, articleNameList)" [value]="0">Select
                    All
                  </mat-option>
                  <mat-option #item *ngFor="let article of articleNameList" [value]="article">
                    {{ article.firstName }} {{article.middleName}} {{article.lastName}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-sm-2">
      <button type="button" class="btn btn-sm btn-block btn-outline-theme" (click)="onViewReport()">
        View Report
      </button>
    </div>
    <div class="col-sm-2" *ngIf="showExportToExcelButton">
      <button (click)="exportToExcelClick()" class="btn btn-sm btn-block btn-outline-theme">
        <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
      </button>
    </div>

    <div class="col-sm-2" *ngIf="showExportToExcelButton">
      <button (click)="exportToPDFClick()" class="btn btn-sm btn-block btn-outline-theme">
        <i class="fa fa-file-pdf-o mr-2"></i>Export as PDF
      </button>
    </div>
  </div>
</div>


<!-- <div class="addPageBreak" id="elementsForPDF">
  <div class="container pt-3" id="mainContent" *ngIf="diaryDebitCreditReportList!=null">
    <div class="row justify-content-center text-center">
      <span class="bg-theme-title">P G BHAGWAT LLP, Chartered Accountants
      </span>
    </div>
    <div class="row justify-content-center text-center ">
      <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
    </div>

    <div class="row mt-2">
      <div class="col-sm-12" style="text-align: center">
        <span class="bg-theme-title">Financial Year {{selectedFinancialYear.name}}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12" style="text-align: center">
        <span class="bg-theme-title">Article Debit Credit</span>
      </div>
    </div>
    <div class="row pt-3">
      <div class="col-sm-5">
        <label class="col-form-label"><b>Role: </b>Article</label>
      </div>
    </div>

    <div class="pb-2">
      <div id="forPageBreak" class="pageBreakClass" *ngFor="let diaryDetails of diaryDebitCreditReportList">
        <div class="row">
          <div class="col-sm-6">
            <label class="col-form-label"><b>Name: </b>{{diaryDetails.firstName}}
              {{diaryDetails.middleName}} {{diaryDetails.lastName}}</label>
          </div>
          <div class="col-sm-6" style="display: flex; justify-content: flex-end">
            <label class="col-form-label"><b>Branch: </b>{{diaryDetails.branch}}</label>
          </div>
        </div>
        <table class="table table-bordered table-sm  table-striped">
          <thead>
            <tr>
              <th>Period</th>
              <th>Opening Balance</th>
              <th colspan="2">Debit Hours</th>
              <th>Credit Hours</th>
              <th>Net Hours</th>
              <th>Closing Balance</th>
              <th>Closing Balance</th>
            </tr>
            <tr>
              <th></th>
              <th></th>
              <th>Work</th>
              <th>Leave</th>
              <th></th>
              <th></th>
              <th></th>
              <th>In Days</th>
            </tr>
          </thead>
          <tbody *ngFor="let restDetail of diaryDetails.deailsRest">
            <tr>
              <td>{{restDetail.month}} - {{restDetail.year}}</td>
              <td>{{restDetail.openingBalance| number : '1.2-2'}}</td>
              <td>{{restDetail.debitHrsWork| number : '1.2-2'}}</td>
              <td>{{restDetail.debitHrsLeave| number : '1.2-2'}}</td>
              <td>{{restDetail.creditHrs| number : '1.2-2'}}</td>
              <td>{{restDetail.netHrs| number : '1.2-2'}}</td>
              <td>{{restDetail.closingBalance| number : '1.2-2'}}</td>
              <td>{{restDetail.closingBalanceInDays| number : '1.2-2'}}</td>
            </tr>
          </tbody>
        </table>
       
      </div>
    </div>

    <div class="container mt-3" *ngIf="leaveDebitCreditReportList!=null">
      <div class="row">
        <div class="col-sm-12" style="text-align: center">
          <span class="bg-theme-title">Leave Details</span>
        </div>
      </div>

      <div class="mt-2">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Employee Name</th>
              <th>Exam Leaves and 1/6 th Eligible Exam Leaves </th>
              <th>Actual CA ExamDays</th>
              <th>Casual Leave</th>
              <th>GMCS1</th>
              <th>GMCS2</th>
              <th>BCOM Leave</th>
            </tr>
          </thead>
          <tbody *ngFor="let leaveDetails of leaveDebitCreditReportList">
            <tr>
              <td>{{leaveDetails.firstName}} {{leaveDetails.middleName}} {{leaveDetails.lastName}}</td>
              <td>{{leaveDetails.eligibleExamLeaves}}</td>
              <td>{{leaveDetails.actualCaExamLeaves}}</td>
              <td>{{leaveDetails.casualLeave}}</td>
              <td>{{leaveDetails.mgcs1}}</td>
              <td>{{leaveDetails.mgcs2}}</td>
              <td>{{leaveDetails.bcomLeave}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

</div> -->


<div class="addPageBreak" id="elementsForPDF">
  <div class="container pt-3" id="mainContent" *ngIf="diaryDebitCreditReportList != null">
    <div class="row justify-content-center text-center">
      <span class="bg-theme-title">
        P G BHAGWAT LLP, Chartered Accountants
      </span>
    </div>

    <div class="row justify-content-center text-center">
      <span>
        Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045
      </span>
    </div>

    <div class="row mt-2">
      <div class="col-sm-12" style="text-align: center">
        <span class="bg-theme-title">
          Financial Year {{selectedFinancialYear.name}}
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12" style="text-align: center">
        <span class="bg-theme-title">
          Article Debit Credit
        </span>
      </div>
    </div>

    <div class="row pt-3">
      <div class="col-sm-5">
        <label class="col-form-label"><b>Role: </b>Article</label>
      </div>
    </div>

    <div class="pb-2">
      <div id="forPageBreak" class="pageBreakClass" *ngFor="let diaryDetails of diaryDebitCreditReportList">
        <div class="row">
          <div class="col-sm-6">
            <label class="col-form-label">
              <b>Name: </b>
              {{diaryDetails.firstName}}
              {{diaryDetails.middleName}}
              {{diaryDetails.lastName}}
            </label>
          </div>

          <div class="col-sm-6" style="display: flex; justify-content: flex-end">
            <label class="col-form-label"><b>Branch: </b>{{diaryDetails.branch}}</label>
          </div>
        </div>

        <table class="table table-bordered table-sm table-striped">
          <thead>
            <tr>
              <th>Period</th>
              <th>Opening Balance</th>
              <th colspan="2">Debit Hours</th>
              <th>Credit Hours</th>
              <th>Net Hours</th>
              <th>Closing Balance</th>
              <th>Closing Balance</th>
            </tr>
            <tr>
              <th></th>
              <th></th>
              <th>Work</th>
              <th>Leave</th>
              <th></th>
              <th></th>
              <th></th>
              <th>In Days</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let restDetail of diaryDetails.deailsRest">
              <td>{{restDetail.month}} - {{restDetail.year}}</td>
              <td>{{restDetail.openingBalance | number : '1.2-2'}}</td>
              <td>{{restDetail.debitHrsWork | number : '1.2-2'}}</td>
              <td>{{restDetail.debitHrsLeave | number : '1.2-2'}}</td>
              <td>{{restDetail.creditHrs | number : '1.2-2'}}</td>
              <td>{{restDetail.netHrs | number : '1.2-2'}}</td>
              <td>{{restDetail.closingBalance | number : '1.2-2'}}</td>
              <td>{{restDetail.closingBalanceInDays | number : '1.2-2'}}</td>
            </tr>
          </tbody>
        </table>

        <div class="container mt-3" *ngIf="diaryDetails.leaveDetail != null">
          <div class="row">
            <div class="col-sm-12" style="text-align: center">
              <span class="bg-theme-title">
                Leave Details
              </span>
            </div>
          </div>

          <div class="mt-2">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>Employee Name</th>
                  <th>Exam Leaves and 1/6 th Eligible Exam Leaves</th>
                  <th>Actual CA ExamDays </th>
                  <th>Casual Leave</th>
                  <th>GMCS1</th>
                  <th>GMCS2</th>
                  <th>BCOM Leave</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{diaryDetails.leaveDetail.firstName}}
                    {{diaryDetails.leaveDetail.middleName}}
                    {{diaryDetails.leaveDetail.lastName}}
                  </td>
                  <td>{{diaryDetails.leaveDetail.eligibleExamLeaves}}</td>
                  <td> {{diaryDetails.leaveDetail.actualCaExamLeaves}}</td>
                  <td>{{diaryDetails.leaveDetail.casualLeave}}</td>
                  <td>{{diaryDetails.leaveDetail.mgcs1}}</td>
                  <td>{{diaryDetails.leaveDetail.mgcs2}}</td>
                  <td>{{diaryDetails.leaveDetail.bcomLeave}}</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
        <div class="html2pdf__page-break"></div>
      </div>
    </div>
  </div>

</div>